new WOW().init();
//mobile nav
var hamburger = document.getElementById('hamburger');
var navbar = document.getElementById('navbar');
hamburger.onchange = function () {
    if (this.checked === true) {
        navbar.classList.add('openmenu');
    } else {
        navbar.classList.remove('openmenu');
    }
};

//header color change
var nav = document.getElementById('navigation');
var firstBlock = document.getElementById('top').offsetHeight - 120;
var secondBlock = firstBlock + document.getElementById('firstimage').offsetHeight + document.getElementById('works').offsetHeight - 120;
var thirdBlock = secondBlock + document.getElementById('firstimage').offsetHeight + document.getElementById('about').offsetHeight - 120;

document.addEventListener('scroll', function(e) {
    if (firstBlock <= window.pageYOffset) {
        nav.classList.add('black');
        nav.classList.remove('blue-first');
        nav.classList.remove('blue-white');
    } else {
        nav.classList.remove('black');
    }
    if (secondBlock <= window.pageYOffset) {
        nav.classList.add('blue-white');
        nav.classList.remove('blue-first');
        nav.classList.remove('black');
    } else {
        nav.classList.remove('blue-white');
    }
    if (thirdBlock <= window.pageYOffset) {
        nav.classList.add('blue-first');
        nav.classList.remove('blue');
        nav.classList.remove('black');
    } else {
        nav.classList.remove('blue-first');
    }
}, true);

//portfolio
/*
var $sContain = $('.swiper-single');

$sContain.each(function(){
    var $this = $(this);
    $this.swiper();
});
*/
/*
var swiper = new Swiper('.swiper-container', {
    slidesPerView: 5,
    slidesPerColumn: 2,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    breakpoints: {
        768: {
            slidesPerView: 1,
            slidesPerColumn: 3
        },
        1024: {
            slidesPerView: 4,
            slidesPerColumn: 2
        },
        900: {
            slidesPerView: 3,
            slidesPerColumn: 2
        }
      }
});
*/
$('.swiper-container').slick({
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

//smooth scroll

(function(window, undefined) // Code in a function to create an isolate scope
{
    'use strict';
    var height_fixed_header = 0, // For layout with header with position:fixed. Write here the height of your header for your anchor don't be hiden behind
        speed = 500,
        moving_frequency = 15, // Affects performance ! High number makes scroll more smooth
        links = document.getElementsByTagName('a'),
        href;

    for(var i = 0; i < links.length; i++)
    {
        href = (links[i].attributes.href === undefined) ? null : links[i].attributes.href.nodeValue.toString();
        if(href !== null && href.length > 1 && href.indexOf('#') != -1) // href.substr(0, 1) == '#'
        {
            links[i].onclick = function()
            {
                var element,
                    href = this.attributes.href.nodeValue.toString(),
                    url = href.substr(0, href.indexOf('#')),
                    id = href.substr(href.indexOf('#') + 1);
                if (element = document.getElementById(id))
                {

                    var hop_count = (speed - (speed % moving_frequency)) / moving_frequency, // Always make an integer
                        getScrollTopDocumentAtBegin = getScrollTopDocument(),
                        gap = (getScrollTopElement(element) - getScrollTopDocumentAtBegin) / hop_count;

                    if (window.history && typeof window.history.pushState == 'function')
                        window.history.pushState({}, undefined, url + '#' + id); // Change URL for modern browser

                    for (var i = 1; i <= hop_count; i++)
                    {
                        (function()
                        {
                            var hop_top_position = gap * i;
                            setTimeout(function(){  window.scrollTo(0, hop_top_position + getScrollTopDocumentAtBegin); }, moving_frequency * i);
                        })();
                    }

                    return false;
                }
            };
        }
    }

    var getScrollTopElement =  function(e)
    {
        var top = height_fixed_header * -1;

        while (e.offsetParent != undefined && e.offsetParent != null)
        {
            top += e.offsetTop + (e.clientTop != null ? e.clientTop : 0);
            e = e.offsetParent;
        }

        return top;
    };

    var getScrollTopDocument = function()
    {
        return window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop !== undefined ? document.documentElement.scrollTop : document.body.scrollTop;
    };
})(window);

"use strict";

(function() {
    var token;

    $(document).ready(function() {
        token = $('input[name="_token"]').val();

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': token
            }
        });

        $("#sendcontact").click(function(e) {
            e.preventDefault();

            $("#contact-form").submit();

            return false;
        });

        $("#contact-form").submit(function(e) {
            e.preventDefault();


            var data = {
                contactname: $("#contactname").val(),
                contactemail: $("#contactemail").val(),
                contactmessage: $("#contactmessage").val()
            }
            sendmail(data);

            return false;
        });

    });

    function sendmail(data)
    {
        $.ajax({
            url: '/contact',
            type: 'POST',
            dataType: 'JSON',
            data: data
        })
        .success(function(response) {
            var data = response;
            $('#errors').empty();
            $('#success').hide();
            if (data.hasOwnProperty('success')) {
                $('.stampsuccess').fadeIn('fast').delay(2500).fadeOut('fast');
            } else {
                $('.stamperror').fadeIn('fast').delay(2500).fadeOut('fast');
            }
            $.each(data, function(i, v) {
                if (i == 'success') {
                    $('#success').show();
                } else {
                    $('#errors').append(v + '<br>');
                }
            });
        })
        .fail(function(response) {
            var data = response;
            $('#errors').empty();
            $('#success').hide();
            $('.stamperror').fadeIn('fast').delay(2500).fadeOut('fast');
            $.each(data, function(k, v) {
                $('#errors').append(v + '<br>');
            });
        });
    }
})();

//$('.tabgroup > div').hide();
//$('.tabgroup > div:first-of-type').addClass('active');
$('.tabs a').click(function(e){
    e.preventDefault();

    var $this = $(this);
    var tabgroup = '#' + $this.parents('.tabs').data('tabgroup');
    var others = $this.closest('li').siblings().children('a');
    var target = $this.data('target');

    others.removeClass('active');
    $this.addClass('active');
    $(tabgroup).children('div').removeClass('active');
    $('#' + target).addClass('active');
    //window.scrollTo(0, 0);
});


$('#gofurther').click(function() {
    $('.readmore-content').toggle( "fast", function() {
        $('#gofurther').hide();
    });
});

$('.mobile-marketing').slick({
    dots: true,
    arrows: false
});
//photoswipe
var initPhotoSwipeFromDOM = function(gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;

        for(var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element

            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };



            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML;
            }

            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                //item.msrc = linkEl.children[0].getAttribute('src');
                item.msrc = '/img/steg-loader.svg';
            }

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) {
                continue;
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if(index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
            params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if(pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            /*
            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            }
            */

        };

        // PhotoSwipe opened from URL
        if(fromURL) {
            if(options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(var j = 0; j < items.length; j++) {
                    if(items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if( isNaN(options.index) ) {
            return;
        }

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
        openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
    }
};

// execute above function
initPhotoSwipeFromDOM('.swiper-wrapper');



//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/app.js
// module id = 1
// module chunks = 0